import React, { useEffect, useRef } from 'react';
//Session user
import SessionConfig from '../config/session_config';

const Dashboard = () => {
  const ref = useRef();
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, []);
  return (
    <SessionConfig ref={ref}/>
  );
};
export default Dashboard;
